import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=2482f28e"
import script from "./CourseModal.vue?vue&type=script&lang=js"
export * from "./CourseModal.vue?vue&type=script&lang=js"
import style0 from "./CourseModal.vue?vue&type=style&index=0&id=2482f28e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VBtn,VCard,VCardText,VCol,VDialog,VIcon,VRow,VTab,VTabItem,VTabs})
